import React from "react";
import {
    Box,
    Stack,
    Typography,
    Chip
} from "@mui/material";
import {
    LocationOn
} from "@mui/icons-material";
import { Operation } from "../../../../networkRequest/operationsService";

interface OperationLocationsProps {
    operation: Operation;
}

const OperationLocations: React.FC<OperationLocationsProps> = ({ operation }) => {
    const getPrimaryLocationInfo = (operation: Operation) => {
        const primaryLocation = operation.operation_locations.find(loc => loc.primary) || operation.operation_locations[0];

        const name = primaryLocation?.name || 'No location specified';

        if (!primaryLocation) {
            return { name, address: '' };
        }

        const addressParts = [
            primaryLocation.street_address_1,
            primaryLocation.street_address_2,
            primaryLocation.city
        ].filter(Boolean);

        // Add state and zip together without comma between them
        if (primaryLocation.state || primaryLocation.zip) {
            const stateZip = [primaryLocation.state, primaryLocation.zip].filter(Boolean).join(' ');
            if (stateZip) {
                addressParts.push(stateZip);
            }
        }

        const address = addressParts.join(', ');

        return { name, address };
    };

    const locationInfo = getPrimaryLocationInfo(operation);
    const additionalLocations = operation.operation_locations.filter(loc => !loc.primary && loc.name !== locationInfo.name);

    return (
        <Box>
            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: 'auto 1fr',
                    gap: 1,
                    alignItems: 'start',
                    pt: 1
                }}
            >
                <LocationOn
                    sx={{
                        mt: '4px'
                    }}
                />
                <Stack spacing={0}>
                    <Typography component="h2" variant="h6" sx={{
                        color: "text.primary"
                    }}>
                        {locationInfo.name}
                    </Typography>
                    {locationInfo.address && (
                        <Typography variant="body1" sx={{
                            color: "text.primary"
                        }}>
                            {locationInfo.address}
                        </Typography>
                    )}

                    {additionalLocations.length > 0 && (
                        <Stack spacing={1} sx={{ mt: 2 }}>
                            <Typography variant="caption" sx={{
                                color: "text.secondary"
                            }}>
                                Additional Locations:
                            </Typography>
                            <Stack direction="row" spacing={1} useFlexGap sx={{
                                flexWrap: "wrap"
                            }}>
                                {additionalLocations.map((location, index) => (
                                    <Chip
                                        key={`${location.name}-${index}`}
                                        label={location.name}
                                        icon={<LocationOn />}
                                        size="small"
                                    />
                                ))}
                            </Stack>
                        </Stack>
                    )}
                </Stack>
            </Box>
        </Box>
    );
};

export default OperationLocations;